module.exports = __webpack_public_path__ + "static/img/goal-08.060bbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/goal-08.png
// module id = DemV
// module chunks = 2